import { type MantineColor } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreBooking } from '@flecto/types'

type DepositStatusInfo = {
  label: string
  color: MantineColor
}

type UseBookingPaymentDepositStatusOptions = {
  booking?: CoreBooking
}

export function useBookingPaymentDepositStatus({
  booking,
}: UseBookingPaymentDepositStatusOptions) {
  const { t } = useTranslation('saas', { keyPrefix: 'bookings' })

  const info: DepositStatusInfo = {
    label: '',
    color: 'gray',
  }

  switch (booking?.payment_deposit_status) {
    case 'payment_deposit_collected':
      info.label = t('deposit_status.payment_deposit_collected')
      info.color = 'green'
      break
    case 'payment_deposit_no_deposit':
      info.label = t('deposit_status.payment_deposit_no_deposit')
      break
    case 'payment_deposit_returned':
      info.label = t('deposit_status.payment_deposit_returned')
      info.color = 'red'
      break
    case 'payment_deposit_to_collect':
      info.label = t('deposit_status.payment_deposit_to_collect')
      info.color = 'red'
      break
    case 'payment_deposit_to_return':
      info.label = t('deposit_status.payment_deposit_to_return')
      info.color = 'red'
      break
    default:
      break
  }

  return info
}
